/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const BadgeCheckIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="badge-check-icon">
      <polyline points="15.809 6.353 10.855 12.647 8.193 9.985" />
      <polyline points="4.21 14.067 0.5 20.482 4.351 19.83 5.686 23.5 8.97 17.984" />
      <polyline points="19.79 14.067 23.5 20.482 19.649 19.83 18.314 23.5 15.03 17.984" />
      <circle cx="12" cy="9.5" r="9" />
    </g>
  </svg>
);

export default BadgeCheckIcon;
